import { dbh_helper } from '../src/dbh_helper';
import { dbh_ajax } from "Ressources/dbh_ajax";
import { dbh_filePreview } from '../Controls/dbh_filePreview';
import { dbh_custom_validation } from '../ClientValidation/dbh_custom_validation';

if (dbh_helper.getUrlArea() == "workflows" && dbh_helper.getUrlController() == "eingangsrechnungen") {
    $(document).ready(function () {
        $('#dbh_DetailsContentXRechnung').ready(() => {
            if ($("#dbh_DetailsContentXRechnung") && $("#dbh_DetailsContentXRechnung").length > 0) {
                $("#dbh_DetailsContentXRechnung").on(
                    'dragover',
                    function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                )
                $("#dbh_DetailsContentXRechnung").on(
                    'dragenter',
                    function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                )

                $("#dbh_DetailsContentXRechnung").on(
                    'drop', function (e) {
                        if (e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files.length && e.originalEvent.dataTransfer.files.length == 1) {
                            e.preventDefault();
                            e.stopPropagation();

                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(e.originalEvent.dataTransfer.files[0]);
                            ($("#FileXRechnung").get(0) as any).files = dataTransfer.files;
                            $("#FileXRechnung").trigger('change');
                        }
                    }
                );

                $("#FileXRechnung").off("change");

                $("#FileXRechnung").on("change", function (e) {
                    $('.dbh_uploadPanel').removeClass('active');
                    $('.dbh_uploadPanelFehler').removeClass('active');
                    $('.dbh_uploadAssistent').addClass('active');

                    var input = this as HTMLInputElement;
                    if (input.files && input.files[0]) {
                        const extension = input.files[0].name.split('.').pop().toLocaleLowerCase();
                        const size = input.files[0].size;
                        const allowedExtension = [".xml"];

                        if (size <= (10 * 1024 * 1024) && allowedExtension.indexOf(`.${extension}`) !== -1) {
                            var form: JQuery<HTMLFormElement> = dbh_helper.findNearestFormJquery($(e.currentTarget));
                            var formData = new FormData(form.get(0));
                            formData.append("File1", input.files[0], input.files[0].name);

                            new dbh_ajax().sendPostRequest({
                                csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                actionName: "GetXRechnungHtml",
                                processData: false, // wichtig für File-Upload
                                contentType: false, // wichtig für File-Upload
                                controllerName: "WorkflowS/Eingangsrechnungen",
                                parameter: formData,
                                callbackSuccess: (ajaxResult: any) => {
                                    $('#xml-container').html(ajaxResult);
                                }
                            });
                        }
                        else {
                            $('.dbh_uploadPanel').addClass('active');
                            $('.dbh_uploadPanelFehler').addClass('active');
                            $('.dbh_uploadAssistent').removeClass('active');
                            input.files = null;
                        }
                    }
                    console.log("asd");
                });
            }
        });

        $('#dbh_DetailsContentEingangsrechnungenAnlegen').ready(() => {
            if ($("#dbh_DetailsContentEingangsrechnungenAnlegen") && $("#dbh_DetailsContentEingangsrechnungenAnlegen").length > 0) {
                $("#btnDruckansicht").on("click", function () {
                    let form = dbh_helper.findNearestForm(this);

                    //new dbh_ajax().sendPostRequest({
                    //    csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                    //    actionName: "Suchen",
                    //    responseType: 'arraybuffer',
                    //    controllerName: "Abrechnungen/Rechnungen",
                    //    parameter: dbh_helper.getParameterStringForForm(form) + "&druckansicht=druckansicht",
                    //    callbackSuccess: (ajaxResult: any) => {
                    //        var file = new Blob([ajaxResult], { type: 'application/pdf' });
                    //        var fileURL = URL.createObjectURL(file);
                    //        window.open(fileURL);
                    //    },
                    //    callbackError: (ajaxResult: object) => {
                    //        console.log(ajaxResult);
                    //    }
                    //});
                });

                $("#dbh_DetailsContentEingangsrechnungenAnlegen").on(
                    'dragover',
                    function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                )
                $("#dbh_DetailsContentEingangsrechnungenAnlegen").on(
                    'dragenter',
                    function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                )

                $("#dbh_DetailsContentEingangsrechnungenAnlegen").on(
                    'drop', function (e) {
                        if (e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files.length && e.originalEvent.dataTransfer.files.length == 1) {
                            e.preventDefault();
                            e.stopPropagation();

                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(e.originalEvent.dataTransfer.files[0]);
                            ($("#File").get(0) as any).files = dataTransfer.files;
                            $("#File").trigger('change');
                        }
                    }
                );

                $("#File").off("change");
                $("#File").on("change", function (tar) {
                    $('.dbh_uploadPanel').removeClass('active');
                    $('.dbh_uploadPanelFehler').removeClass('active');
                    $('.dbh_erAnlageAssistent').addClass('active');

                    var input = this as HTMLInputElement;
                    var firstRender = true;
                    if (input.files && input.files[0]) {
                        const extension = input.files[0].name.split('.').pop().toLocaleLowerCase();
                        const size = input.files[0].size;
                        const allowedExtension = [".pdf", ".xml"];

                        if (size <= (10 * 1024 * 1024) && allowedExtension.indexOf(`.${extension}`) !== -1) {
                            $('#Dateiname').val(input.files[0].name);

                            var reader = new FileReader();

                            reader.onload = function (e) {

                                // XML Datei wird auf Server in ZUGFeRD gewandelt
                                if (extension == "xml") {
                                    var form: JQuery<HTMLFormElement> = dbh_helper.findNearestFormJquery($(tar.currentTarget));
                                    var formData = new FormData(form.get(0));
                                    formData.append("File1", input.files[0], input.files[0].name);

                                    new dbh_ajax().sendPostRequest({
                                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                                        actionName: "GetXRechnungPdf",
                                        processData: false, // wichtig für File-Upload
                                        contentType: false, // wichtig für File-Upload
                                        controllerName: "WorkflowS/Eingangsrechnungen",
                                        parameter: formData,
                                        callbackSuccess: (ajaxResult: any) => {
                                            LoadPdf(firstRender, ajaxResult);
                                        }
                                    });
                                }
                                else {
                                    LoadPdf(firstRender, (e.target.result as any).split(",")[1]);
                                }
                            };

                            reader.readAsDataURL(input.files[0]);
                            SetNummerierung();
                            return true;
                        }
                        else {
                            $('.dbh_uploadPanel').addClass('active');
                            $('.dbh_uploadPanelFehler').addClass('active');
                            $('.dbh_erAnlageAssistent').removeClass('active');
                            input.files = null;
                        }
                    }
                });

                window.setTimeout(() => {
                    $("#mitarbeitende").data("kendoComboBox").bind("change", () => {
                        var object = $("#mitarbeitende").data("kendoComboBox").dataItem();

                        var newEntry = $('<li class="sortable">')
                        newEntry.append($('<span class="sortierung">0</span>'));
                        newEntry.append($('<input type="hidden" value="' + object.PK_Adressen + '" class="FK_Adressen" />'));
                        newEntry.append($('<input type="hidden" value="0" class="UmgangMitAblehnung" />'));
                        var box = $('<div class="box">')
                        box.append($('<a class="draggableIcon"></a>'));
                        var person = $('<div class="person">');
                        if (object.ProfilBildType != null && object.ProfilBildType != undefined && object.ProfilBildType != '') {
                            person.append($('<img src="data:image/' + object.ProfilBildType + ';base64, ' + object.ProfilBildBase64 + '" />'));
                        }
                        else {
                            person.append($('<img src="/styles/Images/ic_account.svg" />'));
                        }
                        if (object.Position != null && object.Position != undefined && object.Position != "") {
                            person.append($('<span class="name">' + object.DisplayName + '<span class="position">' + object.Position + '</span></span>'));
                        }
                        else {
                            person.append($('<span class="name">' + object.DisplayName + '</span>'));
                        }
                        box.append(person);
                        box.append($('<a class="remove"></a>'));
                        newEntry.append(box);

                        $('#workflowSortable').append(newEntry);

                        $("#mitarbeitende").data("kendoComboBox").select(-1);
                        $("#mitarbeitende").data("kendoComboBox").refresh();

                        SetNummerierung();
                        SetEvents();
                    });
                }, 1000);

                (<any>$($('#workflowSortable'))).sortable({
                    update: function (event, ui) {
                        SetNummerierung();
                    }
                });

                SetEvents();

                // ersten Prozess vorauswählen
                window.setTimeout(() => {
                    $('.vorlagenParent input').first().get(0).click();
                    SetNummerierung();
                }, 500);
            }
        });

        $('#dbh_DetailsContentEingangsrechnungenBearbeiten').ready(() => {
            if ($("#dbh_DetailsContentEingangsrechnungenBearbeiten") && $("#dbh_DetailsContentEingangsrechnungenBearbeiten").length > 0) {
                $(document).off("click", "#btnRueckfrage");
                $('#btnRueckfrage').on('click', (e) => {
                    dbh_helper.SendGetRequest("RueckmeldungAnfragenPopupView", "Workflows/Eingangsrechnungen", [['id', $('#PK_Prozesse').val()]], '#popup-placeholder', function () {
                        $("#PopupErRueckmeldungAnfragenViewComponent").show();
                    });

                    e.stopPropagation();
                });

                $(document).off("click", "#PopupErRueckmeldungAnfragenViewComponent #ErRueckmeldungSavetBtn");
                $(document).on("click", "#PopupErRueckmeldungAnfragenViewComponent #ErRueckmeldungSavetBtn", function (e) {
                    const form = dbh_helper.findNearestForm(e.currentTarget);

                    let dbhCustomValidation = new dbh_custom_validation();
                    if (!dbhCustomValidation.validateForm(form)) {
                        return;
                    }
                    var object = $("#mitarbeitende").data("kendoComboBox").dataItem();

                    new dbh_ajax().sendPostRequest({
                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                        actionName: "RueckmeldungAnfragen",
                        controllerName: "Workflows/Eingangsrechnungen",
                        parameter: [
                            ["FK_Prozessschritte", $('#PopupErRueckmeldungAnfragenViewComponent #FK_Prozessschritte').val()],
                            ["FK_Adressen", object.PK_Adressen],
                            ["NeueAnmerkung", $('#PopupErRueckmeldungAnfragenViewComponent #NeueAnmerkung').val()]],
                        callbackSuccess: (ajaxResult: any) => {
                            $("#PopupErRueckmeldungAnfragenViewComponent").hide();
                            $('.dbh_prozessBearbeiten').removeClass("active");
                            $('.dbh_prozessGespeichert').addClass("active");
                            $(document).scrollTop(0);
                            window.setTimeout(function () { (window as any).location = '/workflows/Eingangsrechnungen'; }, 1000);
                        }
                    });
                });

                $(document).off("click", "#PopupErRueckmeldungAnfragenViewComponent #ErRueckmeldungCancelBtn");
                $(document).on("click", "#PopupErRueckmeldungAnfragenViewComponent #ErRueckmeldungCancelBtn", function () {
                    $("#PopupErRueckmeldungAnfragenViewComponent").hide();
                });

                $(document).off("click", "#btnAblehnen");
                $('#btnAblehnen').on('click', (e) => {
                    dbh_helper.SendGetRequest("ErAblehnenPopupView", "Workflows/Eingangsrechnungen", [['id', $('#PK_Prozesse').val()]], '#popup-placeholder', function () {
                        $("#PopupErAblehnenViewComponent").show();
                    });

                    e.stopPropagation();
                });

                $(document).off("click", "#PopupErAblehnenViewComponent #ErAblehnenSavetBtn");
                $(document).on("click", "#PopupErAblehnenViewComponent #ErAblehnenSavetBtn", function (e) {
                    const form = dbh_helper.findNearestForm(e.currentTarget);

                    let dbhCustomValidation = new dbh_custom_validation();
                    if (!dbhCustomValidation.validateForm(form)) {
                        return;
                    }

                    new dbh_ajax().sendPostRequest({
                        csrfToken: form != null && form != undefined ? $('input[name="__RequestVerificationToken"]', $(form)).val()?.toString() : '',
                        actionName: "AblehnenEingangsrechnung",
                        controllerName: "Workflows/Eingangsrechnungen",
                        parameter: [
                            ["PK_Prozesse", $('#PopupErAblehnenViewComponent #PK_Prozesse').val()],
                            ["AblehnungBeendetProzess", $('#PopupErAblehnenViewComponent #hdnAblehnung').val() == "1" ? true : false],
                            ["FK_Prozessschritte", $('#PopupErAblehnenViewComponent #FK_Prozessschritte').val()],
                            ["NeueAnmerkung", $('#PopupErAblehnenViewComponent #NeueAnmerkung').val()]],
                        callbackSuccess: (ajaxResult: any) => {
                            $("#PopupErAblehnenViewComponent").hide();
                            $('.dbh_prozessBearbeiten').removeClass("active");
                            $('.dbh_prozessGespeichert').addClass("active");
                            $(document).scrollTop(0);
                            window.setTimeout(function () { (window as any).location = '/workflows/Eingangsrechnungen'; }, 1000);
                        }
                    });
                });

                $(document).off("click", "#PopupErAblehnenViewComponent #ErAblehnenCancelBtn");
                $(document).on("click", "#PopupErAblehnenViewComponent #ErAblehnenCancelBtn", function () {
                    $("#PopupErAblehnenViewComponent").hide();
                });

                $(document).off("click", "#btnNotizenAnzeigen");
                $('#btnNotizenAnzeigen').on('click', (e) => {
                    dbh_helper.SendGetRequest("NotizenPopupView", "Workflows/Eingangsrechnungen", [['id', $('#PK_Prozesse').val()]], '#popup-placeholder', function () {
                        $("#PopupErNotizenViewComponent").show();
                    });

                    e.stopPropagation();
                });

                $(document).off("click", "#PopupErNotizenViewComponent #ErNotizenCloseBtn");
                $(document).on("click", "#PopupErNotizenViewComponent #ErNotizenCloseBtn", function () {
                    $("#PopupErNotizenViewComponent").hide();
                });
            }
        });
    });

    function LoadPdf(firstRender, dataFromPdf) {
        ($("#pdfviewer") as any).kendoPDFViewer({
            pdfjsProcessing: {
                file: {
                    //retain the base64 data
                    //data: e.target.result
                    data: dataFromPdf
                },
            },
            width: 500,
            height: 634,
            toolbar: {
                items: [
                    "zoom"
                ]
            },
            render: function (e) {
                if (firstRender) {
                    try {
                        e.sender.toolbar.zoom.combobox.value("fitToWidth");
                        e.sender.toolbar.zoom.combobox.trigger("change");

                    } catch (e) {

                    }
                    firstRender = false;
                }
            }
        }).getKendoPDFViewer();
    }

    function SetEvents() {
        // Hauptvorlagen Wechsel = Vorlagen ein und ausblenden
        $('.vorlagenParent input').off("change");
        $('.vorlagenParent input').on("change", (e) => {
            $('.vorlagenParent label').removeClass("active");
            $(e.currentTarget).parents("label").addClass("active");
            $('#workflowSortable .sortable').addClass('hidden');
            $('.btnVorlagen').removeClass("active");
            $('.vorlagen a').hide();
            $(`.vorlagen a[data-parent="${$(e.currentTarget).val()}"]`).show();

            $('#workflowFix .fix').addClass('hidden');
            $(`#workflowFix .fix[data-vorlage="${$(e.currentTarget).val()}"]`).removeClass('hidden');

            SetNummerierung();

            $('#hdnVorlagen').val($(e.currentTarget).val());
        });

        $('.btnVorlagen').off("click");
        $('.btnVorlagen').on("click", function (e) {
            $(e.currentTarget).addClass("clickedReminder");
            $('.btnVorlagen:not(.clickedReminder)').removeClass("active");
            $(e.currentTarget).toggleClass("active");
            $(e.currentTarget).removeClass("clickedReminder");

            $('#workflowSortable .sortable').addClass('hidden');

            $(`#workflowSortable .sortable[data-vorlage="${$(e.currentTarget).data('val')}"]`).removeClass('hidden');
            SetNummerierung();
        });

        $('.remove').off("click");
        $('.remove').on("click", function (e) {
            $(e.currentTarget).parents('.sortable').addClass('hidden')
            SetNummerierung();
        });
    }

    function SetNummerierung() {
        var ausgewaehltePersonen = "";
        var ausgewaehltePersonenUmgangMitAblehnung = "";
        $('.workflow li:visible').each((index, ele) => {
            $(ele).find('.sortierung').html((index + 1).toString() + ".");
            $(ele).find('.hdnSortierung').html((index + 1).toString() + ".");
            if (!$(ele).hasClass('dummy')) {
                ausgewaehltePersonen += $(ele).find('.FK_Adressen').val() + ";";
                ausgewaehltePersonenUmgangMitAblehnung += $(ele).find('.UmgangMitAblehnung').val() + ";";
            }
        });

        $('#hdnAdressenVorlagen').val(ausgewaehltePersonen);
        $('#hdnAdressenVorlagenAusgewaehltePersonenUmgangMitAblehnung').val(ausgewaehltePersonenUmgangMitAblehnung);
    }
}